import { useDropzone } from "react-dropzone";
import React, { useCallback, useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useSelector } from "react-redux";

export default function DropzoneByClick(props: any) {
  const jsonFile = useSelector((state: any) => state.style);

  const [files, setFiles] = useState([]);
  const onDrop = useCallback((acceptedFiles: any) => {
    setFiles(
      acceptedFiles.map((file: Blob | MediaSource) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const imageFiles: any = props.acceptImage
    ? {
        "image/jpeg": [],
        "image/png": [],
        "image/bmp": [],
        // "image/tiff": [],
        // "image/gif": [],
      }
    : {
        "application/zip": [],
        // "application/x-zip": [],
        // "application/x-zip-compressed": [],
        "application/pdf": [],
        "application/x-rar-compressed": [],
        "application/msword": [],
        "application/vnd.ms-excel": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": [],
      };
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: imageFiles,
    onDrop: onDrop,
    noClick: props.errors,
    multiple: false,
  });

  useEffect(() => {
    if (files.length > 0) {
      props.onFileChoosed(acceptedFiles);
    }
  }, [acceptedFiles, props, files.length]);

  return (
    <>
      <Grid
        container
        style={{
          paddingLeft: "10vh !important",
          paddingRight: props.paddingRight,
        }}
        display={props.display === false ? "none" : ""}
      >
        <Grid item>
          <div {...getRootProps()}>
            <input {...getInputProps()} ref={props.inputRef} />
            <Typography
              textAlign={"center"}
              component={"p"}
              width={"20vw"}
              height={"46px"}
              fontWeight={"900"}
              sx={[
                {
                  cursor: "pointer",
                  padding: "1rem",
                  marginY: "1rem",
                  backgroundColor: `${jsonFile?.mainColor}`,
                  color: "#fff",
                  borderRadius: "5px",
                },
              ]}
            >
              بارگذاری فایل
              <PictureAsPdfIcon
                sx={{ marginLeft: "0.5rem" }}
              ></PictureAsPdfIcon>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
